const teams = {
  getTemplate(key) {
    const map = {
      'all-teams': () => ({ teamCode: '-1', teamId: '-1', teamName: 'All Teams' }),
      'unknown-team': () => ({ teamCode: '-2', teamId: '-2', teamName: 'Team Unknown' }),
    }

    return map[key]()
  },

  makeAllAccessTeam({ billingCode, orgName, publisherId }) {
    const newTeam = this.getTemplate('all-teams')

    newTeam.billingCode = billingCode
    newTeam.publisherId = publisherId

    newTeam.teamCode = '-1'
    newTeam.teamId = '-1'

    newTeam.teamName = `${orgName}: All Teams`

    return newTeam
  },

  findTeam(teamId, teamCode, teamsArray = []) {
    const teamIdString = String(teamId, 'Invalid Team ID Given')

    return teamsArray.find((team) => {
      const currentTeamId = String(team.teamId, `Invalid Team ID Found at Team ${team.billingCode}`)

      return teamCode === team.teamCode && currentTeamId === teamIdString
    }) || {}
  },

  getTeamName(networkTeamId, publisher, team = {}) {
    const { isProcessed, teamName = `Team ${networkTeamId}` } = team

    if (isProcessed) return teamName

    const invalidTeamId = !networkTeamId && networkTeamId !== 0
    const { name: publisherName, clientName } = publisher

    if (!publisherName && clientName) return `${clientName}: All Access`
    if (invalidTeamId) return `${publisherName}: Team Unknown`

    // Use teamCode as the comparator so iAdOps-configured Teams and GAM-configured Teams can coexist among the search options.
    if (team.teamCode === '-1') return `${publisherName}: All Teams`

    return `${publisherName}: ${teamName}`
  },
  mapTeamOption(publisher, publisherTeam) {
    const wasAlreadyProcessed = publisher.isProcessed && publisherTeam.isProcessed

    if (wasAlreadyProcessed) return publisherTeam

    const { teamCode = publisherTeam.code, teamId = publisherTeam.id } = publisherTeam
    const team = { ...publisher, ...publisherTeam }
    const { billingCode } = publisher

    const teamName = this.getTeamName(teamId, publisher, team)
    const reportCode = `${billingCode}/${teamCode}`

    team.code = teamCode
    team.id = teamId

    team.teamCode = teamCode
    team.teamName = teamName

    team.reportCode = reportCode
    team.href = `/internal/organization/${reportCode}`

    team.reportId = billingCode
    team.subId = team.hasProductTeams && team.isProductTeam ? teamCode : teamId

    team.isAllAccess = ['-1', 'all'].includes(String(teamCode))

    team.hasHealthAdx = publisher.hasHealthAdx
    team.hasHealthNetwork = publisher.hasHealthNetwork
    team.hasYieldPartner = publisher.hasYieldPartner

    team.operator = 'incl'
    team.text = teamName
    team.value = teamId

    team.isProcessed = true

    return team
  },
}

export default teams
